<router-outlet></router-outlet>
<dx-load-panel
  [visible]="loader.loading$ | async"
  [showIndicator]="true"
  message="در حال بارگزاری..."
  [shading]="true"
  [showPane]="true"
>
</dx-load-panel>
<notifier-container></notifier-container>
